/* ==============================================
   THEME.JS — INTERACTIVE BEHAVIOUR
   ================================================

   This file handles:
   - Opening and closing the cart drawer
   - Adding products to the cart
   - Updating cart item count in the nav
   - Loading cart items into the drawer

   You generally don't need to edit this file.
   ============================================== */


(function () {
  'use strict';

  /* ── Element references ─────────────────────── */
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartToggle   = document.getElementById('cart-toggle');
  const cartClose    = document.getElementById('cart-close');
  const cartBackdrop = document.getElementById('cart-backdrop');
  const cartCount    = document.getElementById('cart-count');
  const cartItems    = document.getElementById('cart-items');
  const cartFooter   = document.getElementById('cart-footer');
  const cartTotal    = document.getElementById('cart-total');


  /* ── Open / Close Cart Drawer ───────────────── */

  function openCart() {
    fetchCart();   // refresh cart contents
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';  // prevent background scrolling
  }

  function closeCart() {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle)   cartToggle.addEventListener('click', openCart);
  if (cartClose)    cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  // Also close drawer if user presses Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });


  /* ── Fetch cart data from Shopify ───────────── */

  function fetchCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function (err) {
        console.error('Could not fetch cart:', err);
      });
  }


  /* ── Render cart items in the drawer ────────── */

  function renderCart(cart) {
    if (!cartItems) return;

    if (cart.items.length === 0) {
      // Empty cart
      cartItems.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    // Build the list of items
    var html = '';
    cart.items.forEach(function (item) {
      var image = item.image
        ? '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item__image">'
        : '<div class="cart-item__image"></div>';

      html += '<div class="cart-item">'
        + image
        + '<div class="cart-item__details">'
        +   '<p class="cart-item__name">' + item.title + '</p>'
        +   '<p class="cart-item__price">Qty: ' + item.quantity + ' — ' + formatMoney(item.line_price) + '</p>'
        +   '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>'
        + '</div>'
        + '</div>';
    });

    cartItems.innerHTML = html;

    // Show footer with total
    if (cartFooter) cartFooter.style.display = 'flex';
    if (cartTotal)  cartTotal.textContent = formatMoney(cart.total_price);

    // Attach remove listeners
    cartItems.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.dataset.key);
      });
    });
  }


  /* ── Remove an item from the cart ───────────── */

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      });
  }


  /* ── Update cart count badge in nav ─────────── */

  function updateCartCount(count) {
    if (!cartCount) return;
    cartCount.textContent = count > 0 ? count : '';
  }


  /* ── Add to cart buttons ────────────────────── */
  // Picks up any button with data-variant-id on the page

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-id]');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Prevent double-clicking
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        fetchCart();   // refresh count
        openCart();    // open the drawer
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      });
  });


  /* ── Helper: format price from Shopify cents ── */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }


  /* ── Load initial cart count on page load ───── */
  fetchCart();

})();


/* ==============================================
   PARALLAX HERO
   The hero background photo moves at a slower
   speed than the page scroll, creating depth.
   You don't need to edit this.
============================================== */

(function () {
  var heroBg = document.querySelector('.hero__bg');
  if (!heroBg) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  function onScroll() {
  var scrollY = window.pageYOffset;
  heroBg.style.transform = 'translateY(' + (scrollY * 0.0) + 'px)';
}

window.addEventListener('scroll', onScroll, { passive: true });
})();


/* ==============================================
   SCROLL FADE-INS
   Watches elements with class "fade-in-section".
   When they enter the viewport, adds "is-visible"
   which triggers the CSS transition.
   You don't need to edit this.
============================================== */

(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var targets = document.querySelectorAll('.fade-in-section');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();


/* ==============================================
   TICKER SPEED CALIBRATION
   Adjusts animation duration so the ticker
   always scrolls at the same speed regardless
   of how many messages you have.
   You don't need to edit this.
============================================== */

(function () {
  var track = document.getElementById('ticker-track');
  if (!track) return;

  document.fonts.ready.then(function () {
    var fullWidth = track.scrollWidth;
    /* 80px per second — increase for faster, decrease for slower */
    var speed    = 65;
    var duration = (fullWidth / 2) / speed;
    track.style.animationDuration = duration + 's';
  });
})();


(function () {
  var carousel = document.querySelector('.instagram-carousel');
  if (!carousel) return;
  var isDown = false;
  var startX;
  var scrollLeft;
  carousel.addEventListener('mousedown', function (e) {
    isDown = true;
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });
  carousel.addEventListener('mouseleave', function () { isDown = false; });
  carousel.addEventListener('mouseup', function () { isDown = false; });
  carousel.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - carousel.offsetLeft;
    var walk = (x - startX) * 1.5;
    carousel.scrollLeft = scrollLeft - walk;
  });
})();



(function () {
  var track = document.getElementById('story-track');
  var dotsWrap = document.getElementById('carousel-dots');
  if (!track) return;
  var slides = track.querySelectorAll('.story-carousel__slide');
  if (slides.length < 2) return;
  var current = 0; var dots = []; var timer;
  slides.forEach(function(_, i) {
    var btn = document.createElement('button');
    btn.className = 'story-carousel__dot' + (i === 0 ? ' is-active' : '');
    btn.addEventListener('click', function() { goTo(i); resetTimer(); });
    dotsWrap.appendChild(btn);
    dots.push(btn);
  });
  function goTo(i) {
    current = i;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function(d, j) { d.classList.toggle('is-active', j === current); });
  }
  function resetTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo((current + 1) % slides.length); }, 4000);
  }
  var carousel = track.closest('.story-carousel');
  carousel.addEventListener('mouseenter', function() { clearInterval(timer); });
  carousel.addEventListener('mouseleave', resetTimer);
  resetTimer();
})();

(function () {
  var headers = document.querySelectorAll('.acc-header');
  headers.forEach(function(header) {
    header.addEventListener('click', function() {
      var isOpen = header.getAttribute('aria-expanded') === 'true';
      headers.forEach(function(h) {
        h.setAttribute('aria-expanded', 'false');
        h.nextElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        header.setAttribute('aria-expanded', 'true');
        header.nextElementSibling.classList.add('is-open');
      }
    });
  });
})();